<!-- <a href="#" target="_blank" class="logo"></a> -->
<div class="logo">
  <img src="assets/img/Biodata-logo.jpg" alt="" class="logo-img">
</div>

